module.exports = __webpack_public_path__ + "static/img/1042.b696d19.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1042.jpg
// module id = 224
// module chunks = 0